var moduleMap = {
	"./taskList": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(309), __webpack_require__.e(139), __webpack_require__.e(681)]).then(function() { return function() { return (__webpack_require__(3375)); }; });
	},
	"./taskType": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(430)]).then(function() { return function() { return (__webpack_require__(7430)); }; });
	},
	"./taskStatistical": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(309), __webpack_require__.e(139), __webpack_require__.e(539)]).then(function() { return function() { return (__webpack_require__(9142)); }; });
	},
	"./inspectionTask": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(309), __webpack_require__.e(923), __webpack_require__.e(139), __webpack_require__.e(528)]).then(function() { return function() { return (__webpack_require__(9973)); }; });
	},
	"./patrolDuty": function() {
		return Promise.all([__webpack_require__.e(670), __webpack_require__.e(309), __webpack_require__.e(923), __webpack_require__.e(667), __webpack_require__.e(139), __webpack_require__.e(591)]).then(function() { return function() { return (__webpack_require__(6283)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});